export default "__VITE_ASSET__CnHPGLor__"